import { render, staticRenderFns } from "./home-bill.vue?vue&type=template&id=272908c3&scoped=true"
import script from "./home-bill.vue?vue&type=script&lang=js"
export * from "./home-bill.vue?vue&type=script&lang=js"
import style0 from "./home-bill.vue?vue&type=style&index=0&id=272908c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272908c3",
  null
  
)

export default component.exports